import {
  isIosNativeApp as isIosApp,
  isAndroidNativeApp as isAndroidApp,
  isNativeApp,
  isGamingWrapperApp,
} from '@central-products/wh-app-detector';

export const isApplication = (callback) => {
  if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
    return false;
  }

  return callback(window.navigator.userAgent);
};

export const isNative = () => isApplication(isNativeApp);
export const isIos = () => isApplication(isIosApp);
export const isAndroid = () => isApplication(isAndroidApp);
export const isGamingWrapper = () => isApplication(isGamingWrapperApp);
